import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { parseUrl as t } from "../utils.js";
import { executeRelationshipQuery as r, executeRelationshipQueryForCount as e } from "./operations/queryRelatedRecords.js";
import o from "../support/FeatureSet.js";
import s from "../support/RelationshipQuery.js";

function n(_x, _x2, _x3) {
  return _n.apply(this, arguments);
}

function _n() {
  _n = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, n, u) {
    var a;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            n = s.from(n);
            a = t(e);
            return _context.abrupt("return", r(a, n, u).then(function (t) {
              var r = t.data,
                  e = {};
              return Object.keys(r).forEach(function (t) {
                return e[t] = o.fromJSON(r[t]);
              }), e;
            }));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _n.apply(this, arguments);
}

function u(_x4, _x5, _x6) {
  return _u.apply(this, arguments);
}

function _u() {
  _u = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(r, o, n) {
    var u;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            o = s.from(o);
            u = t(r);
            return _context2.abrupt("return", e(u, o, _objectSpread({}, n)).then(function (t) {
              return t.data;
            }));

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _u.apply(this, arguments);
}

export { n as executeRelationshipQuery, u as executeRelationshipQueryForCount };